import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getImprovementPlanStatusAndTypeBarChart } from "../api/improvementPlanAPI";

type QueryFnTypeImprovementPlanStatusAndType = typeof getImprovementPlanStatusAndTypeBarChart;

export const useImprovementPlanStatusAndTypeBarChart = (config?: QueryConfig<QueryFnTypeImprovementPlanStatusAndType>) => {
    const filters = useSelector((state: RootState) => state.filters.improvementPlans.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.improvementPlans.filterByCurrentUser ?? false);

    return useQuery<ExtractFnReturnType<QueryFnTypeImprovementPlanStatusAndType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["getImprovementPlanStatusAndTypeBarChart", filterByUser, filters, i18n.language],
        queryFn: () => getImprovementPlanStatusAndTypeBarChart(filters, filterByUser),
    });
}
